import Loadable from "react-loadable";

const LazyEditLivrable = Loadable({
  loader: () => import(/* webpackChunkName: 'livrable-edit' */ "./edit"),
  loading: () => 'loading...'
});

export default LazyEditLivrable;
